export const PROFILE_LANGUAGE_IDS: Record<string, string> = {
  "Arabic": "ar",
  "English": "en",
  "Spanish": "es",
  "Portuguese": "pt",
  "Chinese": "zh",
  "Italian": "it",
  "French": "fr",
  "Russian": "ru",
  "German": "de",
  "Turkish": "tr",
  "Dutch": "nl",
  "Polish": "pl",
  "Japanese": "ja",
  "Malay": "ms",
  "Norwegian": "no",
  "Danish": "da",
  "Romanian": "ro",
  "Swedish": "sv",
  "Bahasa Indonesia": "in",
  "Korean": "ko",
  "Tagalog": "tl",
  "Czech": "cs",
};

export const getProfileLanguageId = (name: string): string | undefined => {
  const id = PROFILE_LANGUAGE_IDS[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for profile language: "${name}" - using text search fallback`);
  }
  return id;
};
